module.exports = "pegasus/assets/theme6/facebook-icon.png";